<div class="tw-relative tw-flex tw-flex-col tw-items-center tw-gap-8 tw-bg-white tw-px-6 tw-py-8 tw-rounded-t-3xl">
  <!-- Close -->
  <div class="tw-absolute tw-right-6 tw-top-6 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-border-none tw-bg-transparent tw-text-gray-800"
       [class.tw-pointer-events-none]="isLoading()"
       [class.tw-opacity-40]="isLoading()"
       (click)="keepAnswers()">
    <cs-icon class="tw-h-3.5 tw-w-3.5" [iconName]="'bottomsheet_close_rounded'"></cs-icon>
  </div>

  <div class="tw-flex tw-flex-col tw-items-center tw-gap-4">
    <cs-icon class="tw-h-12 tw-w-12" [iconName]="'exclamation_orange'"></cs-icon>
    <div class="tw-flex tw-flex-col tw-items-center tw-gap-1 tw-text-center">
      @if (isFaceRegimen) {
        <p class="tw-font-lexend tw-text-600 tw-font-bold tw-text-gray-800" i18n="@@retakeSkinTestConfirmTitle">Are you sure you want to retake the skin test?</p>
      } @else {
        <p class="tw-font-lexend tw-text-600 tw-font-bold tw-text-gray-800" i18n="@@retakeHairTestConfirmTitle">Are you sure you want to retake the hair test?</p>
      }
      <p class="tw-font-body tw-text-300 tw-font-medium tw-text-gray-500" i18n="@@retakeTestConfirmBody">You'll need to answer all questions again. Your current treatment kit will be deleted, and a new kit will be given based on your new answers.</p>
    </div>
  </div>

  <div class="tw-flex tw-w-full tw-flex-col tw-gap-2">
    <button class="tw-w-full tw-rounded-3 tw-border-none tw-bg-teal-600 tw-px-4 tw-py-3 tw-font-lexend tw-text-500 tw-font-semibold tw-text-white disabled:tw-opacity-40"
            [disabled]="isLoading()"
            (click)="keepAnswers()"
            i18n="@@noKeepMyAnswers">No, Keep My Answers</button>
    <button class="tw-flex tw-w-full tw-items-center tw-justify-center tw-rounded-3 tw-border-none tw-bg-transparent tw-px-4 tw-py-3 tw-font-lexend tw-text-500 tw-font-semibold tw-text-teal-600"
            [disabled]="isLoading()"
            (click)="startAgain()">
      @if (isLoading()) {
        <loading [size]="24" [strokeWidth]="3" stroke="var(--cureskin-teal-600)"></loading>
      } @else {
        <span i18n="@@yesStartAgain">Yes, Start Again</span>
      }
    </button>
  </div>
</div>
